"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _RequestStatusTypes = require("settings-ui-sdk/constants/RequestStatusTypes");

var _selectors = require("settings-ui-sdk/Blogs/selectors");

var _actions = require("settings-ui-sdk/BlogNotificationEmails/actions");

var _selectors2 = require("settings-ui-sdk/BlogNotificationEmails/selectors");

var _Blog = _interopRequireDefault(require("settings-ui-sdk/Blogs/Blog"));

var _UpdateBlogSettings = _interopRequireDefault(require("../../stagedObjects/UpdateBlogSettings"));

var _NotificationEmailSettings = require("../../stagedObjects/NotificationEmailSettings");

var _blogSelectors = require("../../selectors/blogSelectors");

var _BlogSettingsPageContainer = _interopRequireDefault(require("../BlogSettingsPageContainer"));

var _AsyncSubscriptionsSettings = _interopRequireDefault(require("./AsyncSubscriptionsSettings"));

var _actions2 = require("settings-ui-sdk/PortalSettings/actions");

var SubscriptionsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SubscriptionsContainer, _PureComponent);

  function SubscriptionsContainer() {
    (0, _classCallCheck2.default)(this, SubscriptionsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubscriptionsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(SubscriptionsContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var blogFromRoute = this.props.blogFromRoute;
      this.props.loadPortalSettings();
      this.props.loadNotificationEmails(blogFromRoute.get('id'));
    }
  }, {
    key: "handleUpdateAdditionalSettings",
    value: function handleUpdateAdditionalSettings() {
      var blogNotificationEmailsForSaving = this.props.blogNotificationEmailsForSaving;
      this.props.updateNotificationEmails(blogNotificationEmailsForSaving);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          updateNotificationEmailsRequestStatus = _this$props.updateNotificationEmailsRequestStatus,
          numberOfAdditionalStagedChanges = _this$props.numberOfAdditionalStagedChanges;
      return _react.default.createElement(_BlogSettingsPageContainer.default, {
        updateAdditionalSettings: function updateAdditionalSettings() {
          return _this.handleUpdateAdditionalSettings();
        },
        updateAdditionalSettingsRequestStatus: updateNotificationEmailsRequestStatus,
        numberOfAdditionalStagedChanges: numberOfAdditionalStagedChanges
      }, _react.default.createElement(_AsyncSubscriptionsSettings.default, null));
    }
  }]);
  return SubscriptionsContainer;
}(_react.PureComponent);

SubscriptionsContainer.propTypes = {
  blogFromRoute: _react.PropTypes.instanceOf(_Blog.default).isRequired,
  loadNotificationEmails: _react.PropTypes.func.isRequired,
  updateNotificationEmails: _react.PropTypes.func.isRequired,
  updateNotificationEmailsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  numberOfAdditionalStagedChanges: _react.PropTypes.number.isRequired,
  blogNotificationEmailsForSaving: _react.PropTypes.object.isRequired,
  loadPortalSettings: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var blogFromRoute = (0, _selectors.getBlogFromRoute)(state);

  var blogFromRouteChanged = _UpdateBlogSettings.default.isChanged('id')(state);

  var numberOfAdditionalStagedChanges = blogFromRouteChanged ? 0 : _NotificationEmailSettings.InstantNotificationEmailSettings.numberOfChanges(state) + _NotificationEmailSettings.DailyNotificationEmailSettings.numberOfChanges(state) + _NotificationEmailSettings.WeeklyNotificationEmailSettings.numberOfChanges(state) + _NotificationEmailSettings.MonthlyNotificationEmailSettings.numberOfChanges(state);
  return {
    blogFromRoute: blogFromRoute,
    numberOfAdditionalStagedChanges: numberOfAdditionalStagedChanges,
    blogNotificationEmailsForSaving: (0, _blogSelectors.getBlogNotificationEmailsForSaving)(state),
    updateNotificationEmailsRequestStatus: (0, _selectors2.getUpdateNotificationEmailsRequestStatus)(blogFromRoute.get('id'))(state)
  };
};

var mapDispatchToProps = {
  loadNotificationEmails: _actions.loadNotificationEmails,
  updateNotificationEmails: _actions.updateNotificationEmails,
  loadPortalSettings: _actions2.loadPortalSettings
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SubscriptionsContainer);

exports.default = _default;
module.exports = exports.default;